module.exports = __webpack_public_path__ + "img/business_and_food_lovers_club.fa1a711c.svg";